// ignore-string-externalization
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import root from './root';
var finalCompose = compose; // (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose; // eslint-disable-line

var store = function store(initalState, context) {
  return createStore(root, initalState, finalCompose(applyMiddleware(thunk.withExtraArgument(context))));
};

export default store;